import React, { useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectPlatformSourceFromApp } from "store/app/selectors";

const Disclaimer = ({ className = "", text, isApp }) => {
    useEffect(() => {
        const linkTimeOut = setTimeout(() => {
            jQuery(".disclaimer a").click(function (e) {
                e.preventDefault();

                isApp ?
                    window?.ReactNativeWebView?.postMessage(
                        JSON.stringify({
                            external_url: jQuery(this).attr("href"),
                        })
                    )
                    :
                    window.open(jQuery(this).attr("href"), "_blank")
            });
        }, 1000);
    }, []);

    return (
        <div className={`disclaimer ${className}`}>
            <div dangerouslySetInnerHTML={{ __html: text }} className="mb-3" />
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    isApp: selectPlatformSourceFromApp,
});

export default connect(mapStateToProps)(Disclaimer);
